import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { generateUniqueId } from "../../../store/utility";

const QuillViewer = (props) => {
  const value = props.value;
  return (
    <ReactQuill
      key={generateUniqueId(10)}
      theme={null}
      value={value}
      readOnly={true}
      modules={{ toolbar: false }}
    />
  );
};

export default QuillViewer;
